import { HttpClient, ApiConfig } from './api/http-client';
import { AxiosError, AxiosResponse } from 'axios';
import useLogger from 'src/composables/loggerUtils';
const logger = useLogger();

export abstract class Services {
  public static apiConfig = {
    secure: true,
    baseURL: process.env.API_URL,
    paramsSerializer: { indexes: null },
  };

  private static handleError = async (api: unknown, error: AxiosError) => {
    const ignoreError = error.response && error.response?.status == 401;
    if (!ignoreError) {
      logger.logError('API Error: ' + error?.message, {
        name: error?.name,
        message: error?.message,
        stack: error?.stack,
        code: error?.code,
        status: error?.status,
        url: error?.config?.baseURL + '' + error?.config?.url,
        method: error?.config.method,
      });
    }
    //console.log('API Error: ' + error.message, error.response?.data);

    return Promise.reject(error);
  };

  public static getService = <T extends HttpClient<unknown>>(service: {
    new (config: ApiConfig<unknown>): T;
  }): T => {
    const api = new service(this.apiConfig);
    api.instance.interceptors.response.use(
      (res: AxiosResponse<unknown, unknown>) => res,
      async (error) => {
        return this.handleError(api, error);
      },
    );
    return api;
  };
}
